import { Checkbox, FormControlLabel } from '@mui/material';
import {
    CheckboxChecked,
    CheckboxUnchecked,
} from '@resurs-internal/mui/components/SelectCheckboxField/SelectCheckboxField';
import { ChangeEvent, useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../../hooks';
import { FieldValidationProps } from '../../hooks/useFieldValidation';
import { addOrUpdateFormField } from '../../store/applicationform';
import { selectFieldStateByName } from '../../store/applicationform/applicationFormSelectors';
import { IFieldState } from '../../store/applicationform/applicationFormTypes';
import InputField from '../InputField/InputField';
import ValidationError from '../ValidationError/ValidationError';
import { CheckboxFieldStyles } from './Checkbox.styles';

type CheckboxFieldProps = {
    name: string;
    label?: string;
    required?: boolean;
    validation?: FieldValidationProps;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    defaultChecked?: boolean;
};

const CheckboxField = (props: CheckboxFieldProps) => {
    const dispatch = useAppDispatch();
    const fieldValue = useAppSelector(selectFieldStateByName)(props.name)?.value;
    const [isChecked, setIsChecked] = useState(props.defaultChecked ? true : fieldValue === 'true');

    useEffect(() => {
        if (props.defaultChecked) {
            dispatch(
                addOrUpdateFormField({
                    fieldName: props.name,
                    value: 'true',
                } as IFieldState),
            );
        }
    }, []);

    const preOnChange = (event: ChangeEvent<HTMLInputElement>): void => {
        const checked = !isChecked;
        setIsChecked(checked);
        event.target.value = checked ? 'true' : '';
        event.target.checked = checked;

        if (props.onChange) {
            props.onChange(event);
        }
    };

    return (
        <CheckboxFieldStyles>
            <InputField preOnChange={preOnChange} {...props}>
                <FormControlLabel
                    control={
                        <Checkbox
                            {...props}
                            checked={isChecked}
                            icon={<CheckboxUnchecked />}
                            checkedIcon={<CheckboxChecked />}
                        />
                    }
                    label={props.label}
                />
            </InputField>
            <ValidationError fieldName={props.name} />
        </CheckboxFieldStyles>
    );
};

export default CheckboxField;
